<div class="d-flex row justify-content-start align-items-end"  style="margin-left: 5px">
    <div class="col-4" *ngFor="let button of buttons; let i = index"
          style="margin-bottom: 5px">
        <button type="button" class="btn btn-outline-primary" style="width: 100%"
                >
                <span
                      style="color: #182F7C!important;font-size: 12px">
                    {{buttons[i].title}}</span>

        </button>
    </div>
</div>
